import { displayFlexRowCenterStyles } from '@app/theme/commonStyles';
import { css, Theme } from '@emotion/react';

export const AmountTotalsStyles = (theme: Theme) => [
  displayFlexRowCenterStyles,
  css({
    padding: '5px',
    height: 55,
    '& .bg': {
      backgroundColor: theme.colors.lightestBlue,
      borderRadius: 10,
    },
  }),
];
